<div class="modal-header">
	<h2>
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
			<g fill="#0CC5D1" fill-rule="evenodd">
				<path d="M25.245 13.141c-8.487 0-12.926-2.08-12.926-3.194V7.36c2.556 1.631 7.763 2.474 12.926 2.474S35.615 8.99 38.17 7.36v2.587c0 1.115-4.44 3.194-12.926 3.194zm0 4.831c-.491 0-.974-.01-1.452-.024a13.514 13.514 0 0 0-4.805-3.624c1.965.287 4.114.433 6.257.433 5.163 0 10.37-.843 12.926-2.474v2.495c0 1.115-4.44 3.194-12.926 3.194zm1.141 4.817a13.204 13.204 0 0 0-1.412-3.204l.27.003c5.164 0 10.37-.843 12.927-2.474v2.495c0 1.064-4.044 3.003-11.785 3.18zm.474 4.815c.032-.374.052-.752.052-1.135 0-.706-.057-1.399-.164-2.075 4.647-.147 9.115-.977 11.423-2.45v2.496c0 1.014-3.881 2.913-11.311 3.164zM13.456 38.181c-6.524 0-11.832-5.254-11.832-11.712 0-6.459 5.308-11.712 11.832-11.712 6.524 0 11.832 5.253 11.832 11.712 0 6.458-5.308 11.712-11.832 11.712zm-1.137-25.898c.506.323 1.117.615 1.81.875a13.622 13.622 0 0 0-.673-.017c-.383 0-.762.02-1.137.051v-.91zM25.245 1.832c8.487 0 12.926 2.078 12.926 3.193 0 1.115-4.44 3.193-12.926 3.193-8.487 0-12.926-2.078-12.926-3.193 0-1.115 4.44-3.193 12.926-3.193zm14.55 3.193c0-3.157-7.32-4.809-14.55-4.809-7.231 0-14.55 1.652-14.55 4.809 0 .143.02.281.049.417h-.05v7.983C4.595 14.69 0 20.057 0 26.469c0 7.348 6.037 13.328 13.456 13.328 6.465 0 11.877-4.54 13.164-10.569 6.49-.187 13.176-1.727 13.176-4.788V5.442h-.05c.03-.136.05-.274.05-.417z"/>
				<path d="M14.124 25.504c-1.815-.747-2.587-1.287-2.587-2.367 0-.83.604-1.784 2.211-1.784 1.336 0 2.192.456 2.63.705l.522-1.37c-.606-.353-1.461-.685-2.713-.726v-2.014h-1.294v2.097c-1.92.312-3.152 1.619-3.152 3.342 0 1.805 1.315 2.76 3.444 3.59 1.545.623 2.359 1.329 2.359 2.47 0 1.183-1.003 2.034-2.484 2.034a5.58 5.58 0 0 1-3.005-.892l-.5 1.391c.729.518 1.982.892 3.192.913v2.097h1.315v-2.16c2.15-.352 3.296-1.888 3.296-3.528 0-1.847-1.085-2.926-3.234-3.798"/>
			</g>
		</svg>
		<ng-container i18n="@@expenses.edit_expenses">Edit Expense</ng-container>
	</h2>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
		</svg>
	</button>
</div>

<div class="modal-body">
	<form [formGroup]="editExpenseForm" (ngSubmit)="onSubmitEditExpense(editExpenseForm)"  class="new-expeses flex-container" #newExpenseForm="ngForm">

		<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('expense_type').errors?.required}">
			<label i18n="@@expenses.expenses_type">Expense Type</label> <span class="req-star">*</span>
			<select nice-select formControlName="expense_type" (change)="onSelectCategory($event.target.value)" >
				<ng-container *ngFor="let type of expenseTypes">
					<ng-container *ngFor="let category of type.categories">
						<option [value]="category.value" >{{ category.label }}</option>
					</ng-container>
				</ng-container>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="half">
			<label i18n="@@expenses.category" >Expenses Category</label> <span class="req-star">*</span>
			<input type="text" name="amount-recieved" placeholder="" i18n-placeholder="@@expenses.general_and_administrative" [value]="selectedType"  disabled />
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && editExpenseForm.get('description').errors?.required}">
			<label> <ng-container i18n="@@expenses.description">Description</ng-container> <span class="req-star">*</span></label>
			<input type="text" name="description" formControlName="description" i18n-placeholder="@@expenses.enter_description"
				placeholder="Type Here" />
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('expense_date').errors?.required}">
			<label i18n="@@expenses.payment_date">Payment Date</label>
			<div class="date-input-wrap">
				<input date-dropper type="text" formControlName="expense_date" data-large-default="true"
					class="date-input" data-dd-format="d/m/Y" data-theme="teamup" />
			</div>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="half">
			<label i18n="@@expenses.vat_include">VAT Included</label>
			<div class="new-create-switch">
				<div class="switch-wrapper">
					<div class="switch">
						<input type="checkbox" id="auto-renew" name="auto-renew" formControlName="vat_include" (ngModelChange)="changeVatInclude(f.vat_include.value)" >
						<span class="slider round"></span>
					</div>
				</div>
			</div>
		</fieldset>

		<ng-container *ngIf="f.vat_include.value; else noVat">

			<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('receipt_number').errors?.required }">
				<label i18n="@@expenses.receipt_invoice_no">Receipt / Invoice No.</label> <span class="req-star">*</span>
				<input type="number" min="0" name="receipt-invoice-no" formControlName="receipt_number" />
				<span class="field-error" i18n="@@error.required">Required</span>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('vendor_name').errors?.required }">
				<label i18n="@@expenses.vendor">Vendor</label> <span class="req-star">*</span>
				<input type="text" name="vendor" formControlName="vendor_name" />
				<span class="field-error" i18n="@@error.required">Required</span>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('vat_number').errors?.required }">
				<label i18n="@@expenses.vat_reg_no">TIN</label> <span class="req-star">*</span>
				<input type="text" name="vat-reg-no" formControlName="vat_number" />
				<span class="field-error" i18n="@@error.required">Required</span>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('taxable_amount').errors?.required }">
				<label i18n="@@expenses.taxable_invoice_amount">Taxable Invoice Amount</label> <span class="req-star">*</span>
				<input type="number" min="0" name="taxable-invoice-amount" formControlName="taxable_amount" (ngModelChange)="updateCast(f.vat_percentage.value, f.taxable_amount.value)" />
				<span class="field-error" i18n="@@error.required">Required</span>
			</fieldset>

			<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('vat_percentage').errors?.required }">
				<label>
					<ng-container i18n="@@expenses.vat_rate"> VAT Rate </ng-container> (%) <span class="req-star">*</span>
				</label>
				<input type="number" min="0" name="vat-rate" formControlName="vat_percentage" (ngModelChange)="updateCast(f.vat_percentage.value, f.taxable_amount.value)" />
				<span class="field-error" i18n="@@error.required">Required</span>
			</fieldset>

			<fieldset class="half">
				<label i18n="@@expenses.net_vat_amount">Net VAT Amount</label>
				<input type="number" min="0" name="net-vat-amount" formControlName="net_vat_amount_percent" />
			</fieldset>
		</ng-container>

		<ng-template #noVat>
			<fieldset class="half" [ngClass]="{'has-error': submitted && editExpenseForm.get('cost').errors?.required}">
				<label>
					<ng-container i18n="@@expenses.amount">Amount</ng-container> <span class="req-star">*</span>
				</label>
				<input type="text" name="cost" formControlName="cost" />
				<span class="field-error" i18n="@@error.required">Required</span>
			</fieldset>
		</ng-template>

		<ng-container *ngIf="receiptFile; else elseTemplate">
			<a href="{{ receiptFile }}"  class="downloadXl d-block mx-auto" i18n="@@common.download_attachment" target="_blank">Download Attachment</a>
		</ng-container>
		<ng-template #elseTemplate>
			<fieldset class="w-100">
				<label i18n="@@expenses.upload_photo_of_invoice">Upload photo of receipt/invoice</label>
				<file-pond #receiptInvoicePhoto 
					class="filepond"
					[options]="pondOptions" 
					[files]="receiptFile"
					(oninit)="pondHandleInit()"
					(onaddfile)="pondHandleAddFile($event)">
				</file-pond>
			</fieldset>
				
		</ng-template>

        <fieldset *ngIf="isProPlan">
            <input class="styled-checkbox" [formControl]="editExpenseForm.controls.vat_include" id="task-tax-new" type="checkbox">
            <label i18n="@@expenses.vat_include" for="task-tax-new">VAT Included?</label>
        </fieldset>
	</form>
</div>

<div class="modal-footer">
	<button type="submit" class="tu-btn pink" i18n="@@common.save" (click)="newExpenseForm.ngSubmit.emit();">Save</button>
</div>